import { render, staticRenderFns } from "./AdicionarPagamentoComissaoDialog.vue?vue&type=template&id=16b5161a&"
import script from "./AdicionarPagamentoComissaoDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarPagamentoComissaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdicionarPagamentoComissaoDialog.vue"
export default component.exports